module.exports = __webpack_public_path__ + "img/icon-other-costs.18497ea1.svg";